module.exports = __webpack_public_path__ + "static/playground-c9ed19dff496fa667089ab9412ba6384.mp4";